import { createContext } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
export const CardContext = /*#__PURE__*/createContext({
  hiddenPrice: false
});
CardContext.displayName = "CardContext";
export function CardContextProvider(_ref) {
  let {
    hiddenPrice = false,
    children
  } = _ref;
  return /*#__PURE__*/_jsx(CardContext.Provider, {
    value: {
      hiddenPrice
    },
    children: children
  });
}